import * as React from 'react';

import { ERentTime, getTermValue } from '../../../../../JsonQuery';
import { DEFAULT_LONGTERM_RENT_OPTION } from '../../../../../JsonQuery/constants';
import { RentalPeriod } from '../../../components/advancedFilters/RentalPeriod';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const RentalPeriodContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  let rentalPeriod = getTermValue('for_day')(jsonQuery);
  if (rentalPeriod === null) {
    rentalPeriod = DEFAULT_LONGTERM_RENT_OPTION;
  }

  const handleChange = React.useCallback(
    (rentalPeriod: ERentTime) => {
      onChange({ action: 'setRentalPeriod', arguments: [rentalPeriod] });
    },
    [onChange],
  );

  return <RentalPeriod value={rentalPeriod} onChange={handleChange} />;
};
